"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PH = void 0;
exports.PH = {
    numericCode: '608',
    alpha2Code: 'PH',
    alpha3Code: 'PHL',
    englishName: {
        short: 'Philippines (the)',
        full: 'the Republic of the Philippines',
    },
    names: {
        full: {
            en: 'the Republic of the Philippines',
            fr: 'la République des Philippines',
            tl: 'Pilipinas',
        },
        short: {
            en: 'Philippines (the)',
            fr: 'Philippines (les)',
            tl: 'Pilipinas',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'tl',
            languageAlpha3Code: 'tgl',
            isAdministrative: true,
        },
    ],
    subdivisions: {
        'PH-00': {
            numericCode: '608',
            code: 'PH-00',
            category: {
                id: '128',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    tl: {
                        singular: 'rehiyon',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'National Capital Region',
                tl: 'Pambansang Punong Rehiyon',
            },
        },
        'PH-01': {
            numericCode: '608',
            code: 'PH-01',
            category: {
                id: '128',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    tl: {
                        singular: 'rehiyon',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Ilocos (Region I)',
                tl: 'Rehiyon ng Iloko',
            },
        },
        'PH-ILN': {
            numericCode: '608',
            code: 'PH-ILN',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-01',
            names: {
                en: 'Ilocos Norte',
                tl: 'Hilagang Iloko',
            },
        },
        'PH-ILS': {
            numericCode: '608',
            code: 'PH-ILS',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-01',
            names: {
                en: 'Ilocos Sur',
                tl: 'Timog Iloko',
            },
        },
        'PH-LUN': {
            numericCode: '608',
            code: 'PH-LUN',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-01',
            names: {
                en: 'La Union',
                tl: 'La Unyon',
            },
        },
        'PH-PAN': {
            numericCode: '608',
            code: 'PH-PAN',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-01',
            names: {
                en: 'Pangasinan',
                tl: 'Pangasinan',
            },
        },
        'PH-02': {
            numericCode: '608',
            code: 'PH-02',
            category: {
                id: '128',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    tl: {
                        singular: 'rehiyon',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Cagayan Valley (Region II)',
                tl: 'Rehiyon ng Lambak ng Kagayan',
            },
        },
        'PH-BTN': {
            numericCode: '608',
            code: 'PH-BTN',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-02',
            names: {
                en: 'Batanes',
                tl: 'Batanes',
            },
        },
        'PH-CAG': {
            numericCode: '608',
            code: 'PH-CAG',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-02',
            names: {
                en: 'Cagayan',
                tl: 'Kagayan',
            },
        },
        'PH-ISA': {
            numericCode: '608',
            code: 'PH-ISA',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-02',
            names: {
                en: 'Isabela',
                tl: 'Isabela',
            },
        },
        'PH-NUV': {
            numericCode: '608',
            code: 'PH-NUV',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-02',
            names: {
                en: 'Nueva Vizcaya',
                tl: 'Nuweva Biskaya',
            },
        },
        'PH-QUI': {
            numericCode: '608',
            code: 'PH-QUI',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-02',
            names: {
                en: 'Quirino',
                tl: 'Kirino',
            },
        },
        'PH-03': {
            numericCode: '608',
            code: 'PH-03',
            category: {
                id: '128',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    tl: {
                        singular: 'rehiyon',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Central Luzon (Region III)',
                tl: 'Rehiyon ng Gitnang Luson',
            },
        },
        'PH-AUR': {
            numericCode: '608',
            code: 'PH-AUR',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-03',
            names: {
                en: 'Aurora',
                tl: 'Aurora',
            },
        },
        'PH-BAN': {
            numericCode: '608',
            code: 'PH-BAN',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-03',
            names: {
                en: 'Bataan',
                tl: 'Bataan',
            },
        },
        'PH-BUL': {
            numericCode: '608',
            code: 'PH-BUL',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-03',
            names: {
                en: 'Bulacan',
                tl: 'Bulakan',
            },
        },
        'PH-NUE': {
            numericCode: '608',
            code: 'PH-NUE',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-03',
            names: {
                en: 'Nueva Ecija',
                tl: 'Nuweva Esiha',
            },
        },
        'PH-PAM': {
            numericCode: '608',
            code: 'PH-PAM',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-03',
            names: {
                en: 'Pampanga',
                tl: 'Pampanga',
            },
        },
        'PH-TAR': {
            numericCode: '608',
            code: 'PH-TAR',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-03',
            names: {
                en: 'Tarlac',
                tl: 'Tarlak',
            },
        },
        'PH-ZMB': {
            numericCode: '608',
            code: 'PH-ZMB',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-03',
            names: {
                en: 'Zambales',
                tl: 'Sambales',
            },
        },
        'PH-05': {
            numericCode: '608',
            code: 'PH-05',
            category: {
                id: '128',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    tl: {
                        singular: 'rehiyon',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Bicol (Region V)',
                tl: 'Rehiyon ng Bikol',
            },
        },
        'PH-ALB': {
            numericCode: '608',
            code: 'PH-ALB',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-05',
            names: {
                en: 'Albay',
                tl: 'Albay',
            },
        },
        'PH-CAN': {
            numericCode: '608',
            code: 'PH-CAN',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-05',
            names: {
                en: 'Camarines Norte',
                tl: 'Hilagang Kamarines',
            },
        },
        'PH-CAS': {
            numericCode: '608',
            code: 'PH-CAS',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-05',
            names: {
                en: 'Camarines Sur',
                tl: 'Timog Kamarines',
            },
        },
        'PH-CAT': {
            numericCode: '608',
            code: 'PH-CAT',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-05',
            names: {
                en: 'Catanduanes',
                tl: 'Katanduwanes',
            },
        },
        'PH-MAS': {
            numericCode: '608',
            code: 'PH-MAS',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-05',
            names: {
                en: 'Masbate',
                tl: 'Masbate',
            },
        },
        'PH-SOR': {
            numericCode: '608',
            code: 'PH-SOR',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-05',
            names: {
                en: 'Sorsogon',
                tl: 'Sorsogon',
            },
        },
        'PH-06': {
            numericCode: '608',
            code: 'PH-06',
            category: {
                id: '128',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    tl: {
                        singular: 'rehiyon',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Western Visayas (Region VI)',
                tl: 'Rehiyon ng Kanlurang Bisaya',
            },
        },
        'PH-AKL': {
            numericCode: '608',
            code: 'PH-AKL',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-06',
            names: {
                en: 'Aklan',
                tl: 'Aklan',
            },
        },
        'PH-ANT': {
            numericCode: '608',
            code: 'PH-ANT',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-06',
            names: {
                en: 'Antique',
                tl: 'Antike',
            },
        },
        'PH-CAP': {
            numericCode: '608',
            code: 'PH-CAP',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-06',
            names: {
                en: 'Capiz',
                tl: 'Kapis',
            },
        },
        'PH-GUI': {
            numericCode: '608',
            code: 'PH-GUI',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-06',
            names: {
                en: 'Guimaras',
                tl: 'Gimaras',
            },
        },
        'PH-ILI': {
            numericCode: '608',
            code: 'PH-ILI',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-06',
            names: {
                en: 'Iloilo',
                tl: 'Iloilo',
            },
        },
        'PH-NEC': {
            numericCode: '608',
            code: 'PH-NEC',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-06',
            names: {
                en: 'Negros Occidental',
                tl: 'Kanlurang Negros',
            },
        },
        'PH-07': {
            numericCode: '608',
            code: 'PH-07',
            category: {
                id: '128',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    tl: {
                        singular: 'rehiyon',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Central Visayas (Region VII)',
                tl: 'Rehiyon ng Gitnang Bisaya',
            },
        },
        'PH-BOH': {
            numericCode: '608',
            code: 'PH-BOH',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-07',
            names: {
                en: 'Bohol',
                tl: 'Bohol',
            },
        },
        'PH-CEB': {
            numericCode: '608',
            code: 'PH-CEB',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-07',
            names: {
                en: 'Cebu',
                tl: 'Sebu',
            },
        },
        'PH-NER': {
            numericCode: '608',
            code: 'PH-NER',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-07',
            names: {
                en: 'Negros Oriental',
                tl: 'Silangang Negros',
            },
        },
        'PH-SIG': {
            numericCode: '608',
            code: 'PH-SIG',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-07',
            names: {
                en: 'Siquijor',
                tl: 'Sikihor',
            },
        },
        'PH-08': {
            numericCode: '608',
            code: 'PH-08',
            category: {
                id: '128',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    tl: {
                        singular: 'rehiyon',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Eastern Visayas (Region VIII)',
                tl: 'Rehiyon ng Silangang Bisaya',
            },
        },
        'PH-BIL': {
            numericCode: '608',
            code: 'PH-BIL',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-08',
            names: {
                en: 'Biliran',
                tl: 'Biliran',
            },
        },
        'PH-EAS': {
            numericCode: '608',
            code: 'PH-EAS',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-08',
            names: {
                en: 'Eastern Samar',
                tl: 'Silangang Samar',
            },
        },
        'PH-LEY': {
            numericCode: '608',
            code: 'PH-LEY',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-08',
            names: {
                en: 'Leyte',
                tl: 'Leyte',
            },
        },
        'PH-NSA': {
            numericCode: '608',
            code: 'PH-NSA',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-08',
            names: {
                en: 'Northern Samar',
                tl: 'Hilagang Samar',
            },
        },
        'PH-SLE': {
            numericCode: '608',
            code: 'PH-SLE',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-08',
            names: {
                en: 'Southern Leyte',
                tl: 'Katimogang Leyte',
            },
        },
        'PH-WSA': {
            numericCode: '608',
            code: 'PH-WSA',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-08',
            names: {
                en: 'Samar',
                tl: 'Samar',
            },
        },
        'PH-09': {
            numericCode: '608',
            code: 'PH-09',
            category: {
                id: '128',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    tl: {
                        singular: 'rehiyon',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Zamboanga Peninsula (Region IX)',
                tl: 'Rehiyon ng Tangway ng Sambuwangga',
            },
        },
        'PH-BAS': {
            numericCode: '608',
            code: 'PH-BAS',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-09',
            names: {
                en: 'Basilan',
                tl: 'Basilan',
            },
        },
        'PH-ZAN': {
            numericCode: '608',
            code: 'PH-ZAN',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-09',
            names: {
                en: 'Zamboanga del Norte',
                tl: 'Hilagang Sambuwangga',
            },
        },
        'PH-ZAS': {
            numericCode: '608',
            code: 'PH-ZAS',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-09',
            names: {
                en: 'Zamboanga del Sur',
                tl: 'Timog Sambuwangga',
            },
        },
        'PH-ZSI': {
            numericCode: '608',
            code: 'PH-ZSI',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-09',
            names: {
                en: 'Zamboanga Sibugay',
                tl: 'Sambuwangga Sibugay',
            },
        },
        'PH-10': {
            numericCode: '608',
            code: 'PH-10',
            category: {
                id: '128',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    tl: {
                        singular: 'rehiyon',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Northern Mindanao (Region X)',
                tl: 'Rehiyon ng Hilagang Mindanaw',
            },
        },
        'PH-BUK': {
            numericCode: '608',
            code: 'PH-BUK',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-10',
            names: {
                en: 'Bukidnon',
                tl: 'Bukidnon',
            },
        },
        'PH-CAM': {
            numericCode: '608',
            code: 'PH-CAM',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-10',
            names: {
                en: 'Camiguin',
                tl: 'Kamigin',
            },
        },
        'PH-MSC': {
            numericCode: '608',
            code: 'PH-MSC',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-10',
            names: {
                en: 'Misamis Occidental',
                tl: 'Kanlurang Misamis',
            },
        },
        'PH-MSR': {
            numericCode: '608',
            code: 'PH-MSR',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-10',
            names: {
                en: 'Misamis Oriental',
                tl: 'Silangang Misamis',
            },
        },
        'PH-11': {
            numericCode: '608',
            code: 'PH-11',
            category: {
                id: '128',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    tl: {
                        singular: 'rehiyon',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Davao (Region XI)',
                tl: 'Rehiyon ng Dabaw',
            },
        },
        'PH-COM': {
            numericCode: '608',
            code: 'PH-COM',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-11',
            names: {
                en: 'Davao de Oro',
            },
        },
        'PH-DAO': {
            numericCode: '608',
            code: 'PH-DAO',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-11',
            names: {
                en: 'Davao Oriental',
                tl: 'Silangang Dabaw',
            },
        },
        'PH-DAS': {
            numericCode: '608',
            code: 'PH-DAS',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-11',
            names: {
                en: 'Davao del Sur',
                tl: 'Timog Dabaw',
            },
        },
        'PH-DAV': {
            numericCode: '608',
            code: 'PH-DAV',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-11',
            names: {
                en: 'Davao del Norte',
                tl: 'Hilagang Dabaw',
            },
        },
        'PH-DVO': {
            numericCode: '608',
            code: 'PH-DVO',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-11',
            names: {
                en: 'Davao Occidental',
                tl: 'Kanlurang Dabaw',
            },
        },
        'PH-SAR': {
            numericCode: '608',
            code: 'PH-SAR',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-11',
            names: {
                en: 'Sarangani',
                tl: 'Sarangani',
            },
        },
        'PH-SCO': {
            numericCode: '608',
            code: 'PH-SCO',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-11',
            names: {
                en: 'South Cotabato',
                tl: 'Timog Kotabato',
            },
        },
        'PH-12': {
            numericCode: '608',
            code: 'PH-12',
            category: {
                id: '128',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    tl: {
                        singular: 'rehiyon',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Soccsksargen (Region XII)',
                tl: 'Rehiyon ng Soccsksargen',
            },
        },
        'PH-LAN': {
            numericCode: '608',
            code: 'PH-LAN',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-12',
            names: {
                en: 'Lanao del Norte',
                tl: 'Hilagang Lanaw',
            },
        },
        'PH-NCO': {
            numericCode: '608',
            code: 'PH-NCO',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-12',
            names: {
                en: 'Cotabato',
                tl: 'Kotabato',
            },
        },
        'PH-SUK': {
            numericCode: '608',
            code: 'PH-SUK',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-12',
            names: {
                en: 'Sultan Kudarat',
                tl: 'Sultan Kudarat',
            },
        },
        'PH-13': {
            numericCode: '608',
            code: 'PH-13',
            category: {
                id: '128',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    tl: {
                        singular: 'rehiyon',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Caraga (Region XIII)',
                tl: 'Rehiyon ng Karaga',
            },
        },
        'PH-AGN': {
            numericCode: '608',
            code: 'PH-AGN',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-13',
            names: {
                en: 'Agusan del Norte',
                tl: 'Hilagang Agusan',
            },
        },
        'PH-AGS': {
            numericCode: '608',
            code: 'PH-AGS',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-13',
            names: {
                en: 'Agusan del Sur',
                tl: 'Timog Agusan',
            },
        },
        'PH-DIN': {
            numericCode: '608',
            code: 'PH-DIN',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-13',
            names: {
                en: 'Dinagat Islands',
                tl: 'Pulo ng Dinagat',
            },
        },
        'PH-SUN': {
            numericCode: '608',
            code: 'PH-SUN',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-13',
            names: {
                en: 'Surigao del Norte',
                tl: 'Hilagang Surigaw',
            },
        },
        'PH-SUR': {
            numericCode: '608',
            code: 'PH-SUR',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-13',
            names: {
                en: 'Surigao del Sur',
                tl: 'Timog Surigaw',
            },
        },
        'PH-14': {
            numericCode: '608',
            code: 'PH-14',
            category: {
                id: '128',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    tl: {
                        singular: 'rehiyon',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Autonomous Region in Muslim Mindanao (ARMM)',
                tl: 'Nagsasariling Rehiyon ng Muslim sa Mindanaw',
            },
        },
        'PH-LAS': {
            numericCode: '608',
            code: 'PH-LAS',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-14',
            names: {
                en: 'Lanao del Sur',
                tl: 'Timog Lanaw',
            },
        },
        'PH-MAG': {
            numericCode: '608',
            code: 'PH-MAG',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-14',
            names: {
                en: 'Maguindanao',
                tl: 'Magindanaw',
            },
        },
        'PH-SLU': {
            numericCode: '608',
            code: 'PH-SLU',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-14',
            names: {
                en: 'Sulu',
                tl: 'Sulu',
            },
        },
        'PH-TAW': {
            numericCode: '608',
            code: 'PH-TAW',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-14',
            names: {
                en: 'Tawi-Tawi',
                tl: 'Tawi-Tawi',
            },
        },
        'PH-15': {
            numericCode: '608',
            code: 'PH-15',
            category: {
                id: '128',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    tl: {
                        singular: 'rehiyon',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Cordillera Administrative Region (CAR)',
                tl: 'Rehiyon ng Administratibo ng Kordilyera',
            },
        },
        'PH-ABR': {
            numericCode: '608',
            code: 'PH-ABR',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-15',
            names: {
                en: 'Abra',
                tl: 'Abra',
            },
        },
        'PH-APA': {
            numericCode: '608',
            code: 'PH-APA',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-15',
            names: {
                en: 'Apayao',
                tl: 'Apayaw',
            },
        },
        'PH-BEN': {
            numericCode: '608',
            code: 'PH-BEN',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-15',
            names: {
                en: 'Benguet',
                tl: 'Benget',
            },
        },
        'PH-IFU': {
            numericCode: '608',
            code: 'PH-IFU',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-15',
            names: {
                en: 'Ifugao',
                tl: 'Ipugaw',
            },
        },
        'PH-KAL': {
            numericCode: '608',
            code: 'PH-KAL',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-15',
            names: {
                en: 'Kalinga',
                tl: 'Kalinga',
            },
        },
        'PH-MOU': {
            numericCode: '608',
            code: 'PH-MOU',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-15',
            names: {
                en: 'Mountain Province',
                tl: 'Lalawigang Bulubundukin',
            },
        },
        'PH-40': {
            numericCode: '608',
            code: 'PH-40',
            category: {
                id: '128',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    tl: {
                        singular: 'rehiyon',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Calabarzon (Region IV-A)',
                tl: 'Rehiyon ng Calabarzon',
            },
        },
        'PH-BTG': {
            numericCode: '608',
            code: 'PH-BTG',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-40',
            names: {
                en: 'Batangas',
                tl: 'Batangas',
            },
        },
        'PH-CAV': {
            numericCode: '608',
            code: 'PH-CAV',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-40',
            names: {
                en: 'Cavite',
                tl: 'Kabite',
            },
        },
        'PH-LAG': {
            numericCode: '608',
            code: 'PH-LAG',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-40',
            names: {
                en: 'Laguna',
                tl: 'Laguna',
            },
        },
        'PH-QUE': {
            numericCode: '608',
            code: 'PH-QUE',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-40',
            names: {
                en: 'Quezon',
                tl: 'Keson',
            },
        },
        'PH-RIZ': {
            numericCode: '608',
            code: 'PH-RIZ',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-40',
            names: {
                en: 'Rizal',
                tl: 'Risal',
            },
        },
        'PH-41': {
            numericCode: '608',
            code: 'PH-41',
            category: {
                id: '128',
                names: {
                    en: {
                        singular: 'region',
                        plural: 'regions',
                    },
                    fr: {
                        singular: 'région',
                        plural: '',
                    },
                    tl: {
                        singular: 'rehiyon',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Mimaropa (Region IV-B)',
                tl: 'Rehiyon ng Mimaropa',
            },
        },
        'PH-MAD': {
            numericCode: '608',
            code: 'PH-MAD',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-41',
            names: {
                en: 'Marinduque',
                tl: 'Marinduke',
            },
        },
        'PH-MDC': {
            numericCode: '608',
            code: 'PH-MDC',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-41',
            names: {
                en: 'Mindoro Occidental',
                tl: 'Kanlurang Mindoro',
            },
        },
        'PH-MDR': {
            numericCode: '608',
            code: 'PH-MDR',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-41',
            names: {
                en: 'Mindoro Oriental',
                tl: 'Silangang Mindoro',
            },
        },
        'PH-PLW': {
            numericCode: '608',
            code: 'PH-PLW',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-41',
            names: {
                en: 'Palawan',
                tl: 'Palawan',
            },
        },
        'PH-ROM': {
            numericCode: '608',
            code: 'PH-ROM',
            category: {
                id: '260',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    tl: {
                        singular: 'lalawigan',
                        plural: '',
                    },
                },
            },
            parent: 'PH-41',
            names: {
                en: 'Romblon',
                tl: 'Romblon',
            },
        },
    },
    cities: [
        {
            name: 'Zamboanga',
            subdivision: 'Zamboanga Peninsula',
        },
        {
            name: 'Wao',
            subdivision: 'Autonomous Region in Muslim Mindanao',
        },
        {
            name: 'Virac',
            subdivision: 'Bicol',
        },
        {
            name: 'Vigan',
            subdivision: 'Ilocos',
        },
        {
            name: 'Victorias',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Victoria',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Veruela',
            subdivision: 'Caraga',
        },
        {
            name: 'Valencia',
            subdivision: 'Northern Mindanao',
        },
        {
            name: 'Urdaneta',
            subdivision: 'Ilocos',
        },
        {
            name: 'Ualog',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Tupi',
            subdivision: 'Davao',
        },
        {
            name: 'Tuguegarao City',
            subdivision: 'Cagayan Valley',
        },
        {
            name: 'Trento',
            subdivision: 'Caraga',
        },
        {
            name: 'Toledo',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Tiwi',
            subdivision: 'Bicol',
        },
        {
            name: 'Ternate',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Teresa',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Telabastagan',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Taytay',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Tayabas',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Tarlac City',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Tanza',
            subdivision: 'Metro Manila',
        },
        {
            name: 'Tanjay',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Tangub',
            subdivision: 'Northern Mindanao',
        },
        {
            name: 'Tandag',
            subdivision: 'Caraga',
        },
        {
            name: 'Tanay',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Tanauan',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Tanauan',
            subdivision: 'Eastern Visayas',
        },
        {
            name: 'Taloc',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Talisay',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Talisay',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Talisay',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Talavera',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Talacogon',
            subdivision: 'Caraga',
        },
        {
            name: 'Tagum',
            subdivision: 'Davao',
        },
        {
            name: 'Taguig',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Tagudin',
            subdivision: 'Ilocos',
        },
        {
            name: 'Tagoloan',
            subdivision: 'Northern Mindanao',
        },
        {
            name: 'Tagbilaran City',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Tagas',
            subdivision: 'Bicol',
        },
        {
            name: 'Tacurong',
            subdivision: 'Soccsksargen',
        },
        {
            name: 'Tabuk',
            subdivision: 'Cordillera',
        },
        {
            name: 'Tabaco',
            subdivision: 'Bicol',
        },
        {
            name: 'Taal',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Surigao',
            subdivision: 'Caraga',
        },
        {
            name: 'Surallah',
            subdivision: 'Soccsksargen',
        },
        {
            name: 'Subic',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Suay',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Sorsogon',
            subdivision: 'Bicol',
        },
        {
            name: 'Solano',
            subdivision: 'Cagayan Valley',
        },
        {
            name: 'Solana',
            subdivision: 'Cagayan Valley',
        },
        {
            name: 'Sitangkai',
            subdivision: 'Autonomous Region in Muslim Mindanao',
        },
        {
            name: 'Sipalay',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Silang',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Sibulan',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Sexmoan',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Sebu',
            subdivision: 'Soccsksargen',
        },
        {
            name: 'Sariaya',
            subdivision: 'Calabarzon',
        },
        {
            name: 'San Vicente',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Santo Tomas',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Santol',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Santiago',
            subdivision: 'Cagayan Valley',
        },
        {
            name: 'Santa Rosa',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Santa Maria',
            subdivision: 'Ilocos',
        },
        {
            name: 'Santa Maria',
            subdivision: 'Davao',
        },
        {
            name: 'Santa Cruz',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Santa Cruz',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Santa Cruz',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Santa Catalina',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Santa Barbara',
            subdivision: 'Ilocos',
        },
        {
            name: 'Santa Ana',
            subdivision: 'Central Luzon',
        },
        {
            name: 'San Simon',
            subdivision: 'Central Luzon',
        },
        {
            name: 'San Pedro',
            subdivision: 'Calabarzon',
        },
        {
            name: 'San Pascual',
            subdivision: 'Calabarzon',
        },
        {
            name: 'San Pablo',
            subdivision: 'Calabarzon',
        },
        {
            name: 'San Nicolas',
            subdivision: 'Ilocos',
        },
        {
            name: 'San Narciso',
            subdivision: 'Central Luzon',
        },
        {
            name: 'San Miguel',
            subdivision: 'Central Luzon',
        },
        {
            name: 'San Miguel',
            subdivision: 'Central Luzon',
        },
        {
            name: 'San Mateo',
            subdivision: 'Cagayan Valley',
        },
        {
            name: 'San Mateo',
            subdivision: 'Calabarzon',
        },
        {
            name: 'San Mariano',
            subdivision: 'Davao',
        },
        {
            name: 'San Marcelino',
            subdivision: 'Central Luzon',
        },
        {
            name: 'San Luis',
            subdivision: 'Central Luzon',
        },
        {
            name: 'San Leonardo',
            subdivision: 'Central Luzon',
        },
        {
            name: 'San Juan',
            subdivision: 'Metro Manila',
        },
        {
            name: 'San Jose del Monte',
            subdivision: 'Central Luzon',
        },
        {
            name: 'San Jose',
            subdivision: 'Bicol',
        },
        {
            name: 'San Jose',
            subdivision: 'Mimaropa',
        },
        {
            name: 'San Ildefonso',
            subdivision: 'Central Luzon',
        },
        {
            name: 'San Francisco',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Aurora',
            subdivision: 'Calabarzon',
        },
        {
            name: 'San Francisco',
            subdivision: 'Caraga',
        },
        {
            name: 'San Fernando',
            subdivision: 'Ilocos',
        },
        {
            name: 'San Fernando',
            subdivision: 'Central Luzon',
        },
        {
            name: 'San Fernando',
            subdivision: 'Central Visayas',
        },
        {
            name: 'San Antonio',
            subdivision: 'Central Luzon',
        },
        {
            name: 'San Antonio',
            subdivision: 'Central Luzon',
        },
        {
            name: 'San Antonio',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Sampaloc',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Samal',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Samal',
            subdivision: 'Davao',
        },
        {
            name: 'Sagay',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Sablayan',
            subdivision: 'Mimaropa',
        },
        {
            name: 'Roxas',
            subdivision: 'Cagayan Valley',
        },
        {
            name: 'Roxas City',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Roxas',
            subdivision: 'Mimaropa',
        },
        {
            name: 'Romblon',
            subdivision: 'Mimaropa',
        },
        {
            name: 'Rizal',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Recodo',
            subdivision: 'Zamboanga Peninsula',
        },
        {
            name: 'Ramos',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Ramon',
            subdivision: 'Cagayan Valley',
        },
        {
            name: 'Quiapo',
            subdivision: 'Metro Manila',
        },
        {
            name: 'Quezon City',
            subdivision: 'Metro Manila',
        },
        {
            name: 'Quezon',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Quezon',
            subdivision: 'Northern Mindanao',
        },
        {
            name: 'Pulupandan',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Pulong Santa Cruz',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Pulilan',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Puerto Princesa',
            subdivision: 'Mimaropa',
        },
        {
            name: 'Port Area',
            subdivision: 'Metro Manila',
        },
        {
            name: 'Porac',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Polomolok',
            subdivision: 'Davao',
        },
        {
            name: 'Polangui',
            subdivision: 'Bicol',
        },
        {
            name: 'Plaridel',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Pio',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Pinamungahan',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Pinamalayan',
            subdivision: 'Mimaropa',
        },
        {
            name: 'Pililla',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Pilar',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Pila',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Peñaranda',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Patuto',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Passi',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Parang',
            subdivision: 'Autonomous Region in Muslim Mindanao',
        },
        {
            name: 'Paraiso',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Papaya',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Paombong',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Pantubig',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Paniqui',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Pangil',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Pandi',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Pandacaqui',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Panalanoy',
            subdivision: 'Eastern Visayas',
        },
        {
            name: 'Panabo',
            subdivision: 'Davao',
        },
        {
            name: 'Palo',
            subdivision: 'Eastern Visayas',
        },
        {
            name: 'Palayan City',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Pagbilao',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Pagaluñgan',
            subdivision: 'Autonomous Region in Muslim Mindanao',
        },
        {
            name: 'Pagadian',
            subdivision: 'Zamboanga Peninsula',
        },
        {
            name: 'Paete',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Pacol',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Ozamiz City',
            subdivision: 'Northern Mindanao',
        },
        {
            name: 'Oroquieta',
            subdivision: 'Northern Mindanao',
        },
        {
            name: 'Ormoc',
            subdivision: 'Eastern Visayas',
        },
        {
            name: 'Orion',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Orani',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Olongapo',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Obando',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Noveleta',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Norzagaray',
            subdivision: 'Central Luzon',
        },
        {
            name: 'New Corella',
            subdivision: 'Davao',
        },
        {
            name: 'Nasugbu',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Narra',
            subdivision: 'Mimaropa',
        },
        {
            name: 'Naic',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Nagcarlan',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Naga',
            subdivision: 'Bicol',
        },
        {
            name: 'Naga',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Nabunturan',
            subdivision: 'Davao',
        },
        {
            name: 'Nabua',
            subdivision: 'Bicol',
        },
        {
            name: 'Muricay',
            subdivision: 'Zamboanga Peninsula',
        },
        {
            name: 'Murcia',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Muñoz',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Morong',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Morong',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Rodriguez',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Monkayo',
            subdivision: 'Davao',
        },
        {
            name: 'Molave',
            subdivision: 'Zamboanga Peninsula',
        },
        {
            name: 'Minglanilla',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Midsayap',
            subdivision: 'Soccsksargen',
        },
        {
            name: 'Meycauayan',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Mexico',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Mercedes',
            subdivision: 'Bicol',
        },
        {
            name: 'Mendez-Nuñez',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Mauban',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Mati',
            subdivision: 'Davao',
        },
        {
            name: 'Masinloc',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Masbate',
            subdivision: 'Bicol',
        },
        {
            name: 'Masantol',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Mariveles',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Marilao',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Mariano',
            subdivision: 'Northern Mindanao',
        },
        {
            name: 'Marawi City',
            subdivision: 'Autonomous Region in Muslim Mindanao',
        },
        {
            name: 'Maramag',
            subdivision: 'Northern Mindanao',
        },
        {
            name: 'Maragondon',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Mantampay',
            subdivision: 'Northern Mindanao',
        },
        {
            name: 'Mansilingan',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Mansalay',
            subdivision: 'Mimaropa',
        },
        {
            name: 'Manolo Fortich',
            subdivision: 'Northern Mindanao',
        },
        {
            name: 'Manila',
            subdivision: 'Metro Manila',
        },
        {
            name: 'Manibaug Pasig',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Mangaldan',
            subdivision: 'Ilocos',
        },
        {
            name: 'Mandaue City',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Mandaluyong City',
            subdivision: 'Metro Manila',
        },
        {
            name: 'Mankayan',
            subdivision: 'Cordillera',
        },
        {
            name: 'Manay',
            subdivision: 'Davao',
        },
        {
            name: 'Manapla',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Manaoag',
            subdivision: 'Ilocos',
        },
        {
            name: 'Mamburao',
            subdivision: 'Mimaropa',
        },
        {
            name: 'Mamatid',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Malvar',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Maluso',
            subdivision: 'Autonomous Region in Muslim Mindanao',
        },
        {
            name: 'Maluñgun',
            subdivision: 'Soccsksargen',
        },
        {
            name: 'Malolos',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Malita',
            subdivision: 'Davao',
        },
        {
            name: 'Malilipot',
            subdivision: 'Bicol',
        },
        {
            name: 'Malaybalay',
            subdivision: 'Northern Mindanao',
        },
        {
            name: 'Malapatan',
            subdivision: 'Soccsksargen',
        },
        {
            name: 'Malanday',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Malabanban Norte',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Makati City',
            subdivision: 'Metro Manila',
        },
        {
            name: 'Mahayag',
            subdivision: 'Zamboanga Peninsula',
        },
        {
            name: 'Magsaysay',
            subdivision: 'Davao',
        },
        {
            name: 'Magarao',
            subdivision: 'Bicol',
        },
        {
            name: 'Maganoy',
            subdivision: 'Autonomous Region in Muslim Mindanao',
        },
        {
            name: 'Magalang',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Mabalacat City',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Maasin',
            subdivision: 'Eastern Visayas',
        },
        {
            name: 'Maao',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Lupon',
            subdivision: 'Davao',
        },
        {
            name: 'Lumbang',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Lucena',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Lucban',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Lubao',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Los Baños',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Lopez',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Loma de Gato',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Loboc',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Lipa City',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Lingayen',
            subdivision: 'Ilocos',
        },
        {
            name: 'Limay',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Liloan',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Lilio',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Libon',
            subdivision: 'Bicol',
        },
        {
            name: 'Libertad',
            subdivision: 'Caraga',
        },
        {
            name: 'Legaspi',
            subdivision: 'Bicol',
        },
        {
            name: 'Laur',
            subdivision: 'Central Luzon',
        },
        {
            name: 'La Trinidad',
            subdivision: 'Cordillera',
        },
        {
            name: 'Lapu-Lapu City',
            subdivision: 'Central Visayas',
        },
        {
            name: 'La Paz',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Laoang',
            subdivision: 'Eastern Visayas',
        },
        {
            name: 'Laoag',
            subdivision: 'Ilocos',
        },
        {
            name: 'Lala',
            subdivision: 'Northern Mindanao',
        },
        {
            name: 'Laguilayan',
            subdivision: 'Soccsksargen',
        },
        {
            name: 'La Castellana',
            subdivision: 'Western Visayas',
        },
        {
            name: 'La Carlota',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Labo',
            subdivision: 'Bicol',
        },
        {
            name: 'Koronadal',
            subdivision: 'Soccsksargen',
        },
        {
            name: 'Kidapawan',
            subdivision: 'Soccsksargen',
        },
        {
            name: 'Kawit',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Kalibo (poblacion)',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Kabankalan',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Kabacan',
            subdivision: 'Soccsksargen',
        },
        {
            name: 'Jose Pañganiban',
            subdivision: 'Bicol',
        },
        {
            name: 'Jolo',
            subdivision: 'Autonomous Region in Muslim Mindanao',
        },
        {
            name: 'Jasaan',
            subdivision: 'Northern Mindanao',
        },
        {
            name: 'Jalajala',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Jagna',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Jaen',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Itogon',
            subdivision: 'Cordillera',
        },
        {
            name: 'Isulan',
            subdivision: 'Soccsksargen',
        },
        {
            name: 'Isabela',
            subdivision: 'Western Visayas',
        },
        {
            name: 'City of Isabela',
            subdivision: 'Autonomous Region in Muslim Mindanao',
        },
        {
            name: 'Irosin',
            subdivision: 'Bicol',
        },
        {
            name: 'Iriga City',
            subdivision: 'Bicol',
        },
        {
            name: 'Ipil',
            subdivision: 'Zamboanga Peninsula',
        },
        {
            name: 'Indang',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Imus',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Iloilo',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Iligan City',
            subdivision: 'Soccsksargen',
        },
        {
            name: 'Ilagan',
            subdivision: 'Cagayan Valley',
        },
        {
            name: 'Iba',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Hinigaran',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Himamaylan',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Hermosa',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Hagonoy',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Guyong',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Gumaca',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Guiset East',
            subdivision: 'Ilocos',
        },
        {
            name: 'Guimba',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Guihulñgan',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Guiguinto',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Goa',
            subdivision: 'Bicol',
        },
        {
            name: 'Glan',
            subdivision: 'Soccsksargen',
        },
        {
            name: 'Gerona',
            subdivision: 'Central Luzon',
        },
        {
            name: 'General Trias',
            subdivision: 'Calabarzon',
        },
        {
            name: 'General Tinio',
            subdivision: 'Central Luzon',
        },
        {
            name: 'General Santos',
            subdivision: 'Soccsksargen',
        },
        {
            name: 'General Mamerto Natividad',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Gapan',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Escalante',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Saravia',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Dumaguete',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Don Carlos',
            subdivision: 'Northern Mindanao',
        },
        {
            name: 'Domalanoan',
            subdivision: 'Ilocos',
        },
        {
            name: 'Dologon',
            subdivision: 'Northern Mindanao',
        },
        {
            name: 'Dipolog',
            subdivision: 'Zamboanga Peninsula',
        },
        {
            name: 'Dinalupihan',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Digos',
            subdivision: 'Davao',
        },
        {
            name: 'Diadi',
            subdivision: 'Cagayan Valley',
        },
        {
            name: 'Del Pilar',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Davao',
            subdivision: 'Davao',
        },
        {
            name: 'Dasmariñas',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Dapitan',
            subdivision: 'Zamboanga Peninsula',
        },
        {
            name: 'Danao',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Danao',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Daet',
            subdivision: 'Bicol',
        },
        {
            name: 'Cuenca',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Cotabato',
            subdivision: 'Autonomous Region in Muslim Mindanao',
        },
        {
            name: 'Cordova',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Consolacion',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Concepcion',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Concepcion Ibaba',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Compostela',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Compostela',
            subdivision: 'Davao',
        },
        {
            name: 'Cebu City',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Cavite City',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Catbalogan',
            subdivision: 'Eastern Visayas',
        },
        {
            name: 'Catarman',
            subdivision: 'Eastern Visayas',
        },
        {
            name: 'Catanauan',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Castillejos',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Carmona',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Cogan',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Carigara',
            subdivision: 'Eastern Visayas',
        },
        {
            name: 'Cardona',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Carcar',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Capas',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Canlaon',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Candelaria',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Candaba',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Camiling',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Calumpit',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Calumpang',
            subdivision: 'Metro Manila',
        },
        {
            name: 'Calbayog City',
            subdivision: 'Eastern Visayas',
        },
        {
            name: 'Calauan',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Calauag',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Calatagan',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Calasiao',
            subdivision: 'Ilocos',
        },
        {
            name: 'Calapan',
            subdivision: 'Mimaropa',
        },
        {
            name: 'Calamba',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Calaca',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Calabanga',
            subdivision: 'Bicol',
        },
        {
            name: 'Cainta',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Cagayan de Oro',
            subdivision: 'Northern Mindanao',
        },
        {
            name: 'Cadiz',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Cabiao',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Cabayangan',
            subdivision: 'Davao',
        },
        {
            name: 'Cabanatuan City',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Cabagan',
            subdivision: 'Cagayan Valley',
        },
        {
            name: 'Cabadbaran',
            subdivision: 'Caraga',
        },
        {
            name: 'Butuan',
            subdivision: 'Caraga',
        },
        {
            name: 'Bustos',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Boroon',
            subdivision: 'Northern Mindanao',
        },
        {
            name: 'Burgos',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Bunawan',
            subdivision: 'Caraga',
        },
        {
            name: 'Buluan',
            subdivision: 'Autonomous Region in Muslim Mindanao',
        },
        {
            name: 'Bulaon',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Bulan',
            subdivision: 'Bicol',
        },
        {
            name: 'Bulacan',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Buhi',
            subdivision: 'Bicol',
        },
        {
            name: 'Bugo',
            subdivision: 'Northern Mindanao',
        },
        {
            name: 'Buenavista',
            subdivision: 'Caraga',
        },
        {
            name: 'Budta',
            subdivision: 'Autonomous Region in Muslim Mindanao',
        },
        {
            name: 'Botolan',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Borongan',
            subdivision: 'Eastern Visayas',
        },
        {
            name: 'Bongao',
            subdivision: 'Autonomous Region in Muslim Mindanao',
        },
        {
            name: 'Bongabon',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Bogo',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Bocaue',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Bislig',
            subdivision: 'Caraga',
        },
        {
            name: 'Binonga',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Binmaley',
            subdivision: 'Ilocos',
        },
        {
            name: 'Binangonan',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Binalbagan',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Bignay Uno',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Bayugan',
            subdivision: 'Caraga',
        },
        {
            name: 'Bayombong',
            subdivision: 'Cagayan Valley',
        },
        {
            name: 'Baybay',
            subdivision: 'Eastern Visayas',
        },
        {
            name: 'Bayawan',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Bayambang',
            subdivision: 'Ilocos',
        },
        {
            name: 'Bay',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Bauang',
            subdivision: 'Ilocos',
        },
        {
            name: 'Bauan',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Bato',
            subdivision: 'Bicol',
        },
        {
            name: 'Batangas',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Batac City',
            subdivision: 'Ilocos',
        },
        {
            name: 'Baras',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Bantayan',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Bansalan',
            subdivision: 'Davao',
        },
        {
            name: 'Bañga',
            subdivision: 'Soccsksargen',
        },
        {
            name: 'Banaybanay',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Bambang',
            subdivision: 'Cagayan Valley',
        },
        {
            name: 'Baliuag',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Balayan',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Balanga',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Balamban',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Balagtas',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Bais',
            subdivision: 'Central Visayas',
        },
        {
            name: 'Bah-Bah',
            subdivision: 'Caraga',
        },
        {
            name: 'Baguio',
            subdivision: 'Cordillera',
        },
        {
            name: 'Bago City',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Baggabag B',
            subdivision: 'Cagayan Valley',
        },
        {
            name: 'Bacoor',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Bacolod City',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Babo-Pangulo',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Baao',
            subdivision: 'Bicol',
        },
        {
            name: 'Atimonan',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Asia',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Aringay',
            subdivision: 'Ilocos',
        },
        {
            name: 'Arayat',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Aparri',
            subdivision: 'Cagayan Valley',
        },
        {
            name: 'Apalit',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Antipolo',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Angono',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Angeles City',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Angat',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Amadeo',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Alicia',
            subdivision: 'Cagayan Valley',
        },
        {
            name: 'Aliaga',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Alaminos',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Alabel',
            subdivision: 'Soccsksargen',
        },
        {
            name: 'Agoo',
            subdivision: 'Ilocos',
        },
        {
            name: 'Abuyog',
            subdivision: 'Eastern Visayas',
        },
        {
            name: 'Abucay',
            subdivision: 'Central Luzon',
        },
        {
            name: 'Bagong Pagasa',
            subdivision: 'Calabarzon',
        },
        {
            name: 'Malingao',
            subdivision: 'Soccsksargen',
        },
        {
            name: 'Pasig City',
            subdivision: 'Metro Manila',
        },
        {
            name: 'Pandan',
            subdivision: 'Western Visayas',
        },
        {
            name: 'Apas',
            subdivision: 'Central Visayas',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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